import { ArrowRight } from "lucide-react";
import type { Schema } from "./api";
import { dollars } from "./budget";
import { budgetLine, stopNotice } from "./jobs";

/** Why the latest analysis stopped, who can fix it, what is saved and how to continue the same job. */
export function AnalysisStopNotice({ job, canEdit, resume, openFiles, stopAuto }: {
  job: Schema["JobOut"] | undefined; canEdit: boolean; resume: () => void; openFiles: () => void;
  /** Withdraws the retry scheduled for a subscription reset; the job stays resumable by hand. */
  stopAuto: () => void;
}) {
  const notice = stopNotice(job, canEdit);
  if (!notice) return null;
  const act = notice.action === "files" ? openFiles : notice.action === "stop_auto" ? stopAuto : resume;
  return <div className="notice" role={notice.role}>
    <span>
      <strong>{notice.title}</strong> {notice.message}
      <small className="budget-summary">{notice.advice}</small>
      {job?.budget && <small className="budget-summary">{budgetLine(job.budget, dollars)}</small>}
      {notice.detail && <details className="budget-summary"><summary>Техническая запись для администратора</summary><pre>{notice.detail}</pre></details>}
    </span>
    {notice.action && <button className="quiet" onClick={act}>{notice.actionLabel} <ArrowRight size={14} /></button>}
  </div>;
}
